import { AppointmentStatus, translateAppointmentStatus } from "@model/models";

export default (status: AppointmentStatus) => {
    return translateAppointmentStatus(status);
}